"use client"

import { AboutHero } from "@/features/client/sections/About/AHero"
import { AboutStory } from "@/features/client/sections/About/Story"
import { AboutMission } from "@/features/client/sections/About/MissionVission"
import { AboutCertifications } from "@/features/client/sections/About/AboutAccreditation"

const About = () => {
  return (
    <main className="min-h-screen bg-white">
      <AboutHero />
      <AboutStory />
      <AboutMission />
      <AboutCertifications />
    </main>
  )
}

export default About
